/* Sponsoring-Versand-Page - Form auf /pages/sponsoring-versand?token=...
 *
 * Flow:
 *   1. token aus URL lesen
 *   2. GET /apps/rma/api/sponsoring/load?token=...
 *      -> ok           : Form anzeigen, Adress-Vorbelegung
 *      -> rejected     : "Anfrage geschlossen"
 *      -> already-     : "Bereits eingereicht"
 *        submitted
 *      -> not-found    : "Link ungültig"
 *      -> alles andere : ein automatischer zweiter Versuch, dann Fehlerseite
 *                        mit technischer Angabe (HTTP-Code o.ae.) und
 *                        "Erneut versuchen"-Knopf
 *   3. User waehlt 1-4 Themen + fuellt Adresse aus
 *   4. POST /apps/rma/api/sponsoring/submit (JSON-Body)
 *      -> bei Erfolg: Success-Page
 *      -> technischer Fehler: ein automatischer zweiter Versuch, dann bleibt
 *         das Formular stehen, mit Hinweis auf den Weg per Mail
 *
 * Hinweis: Shopify erlaubt nur einen App-Proxy pro App; der haengt fest
 * unter /apps/rma/* (siehe shopify.app.toml). Deshalb laeuft auch das
 * Sponsoring-API ueber den rma-Subpfad.
 */
(function () {
  'use strict';

  const root = document.querySelector('.sponsoring-page');
  if (!root) return;

  const strings = JSON.parse(decodeHtmlEntities(root.dataset.strings || '{}'));
  const form = root.querySelector('[data-form="sponsoring"]');
  const params = new URLSearchParams(window.location.search);
  const token = (params.get('token') || '').trim();

  if (!token) {
    showState('NOT_FOUND');
    return;
  }

  // Ein erster Fehlschlag ist meist ein Aussetzer (Kaltstart im Backend,
  // Timeout im Shopify-Proxy, kurzer Netzhaenger). Deshalb einmal automatisch
  // nachfassen, bevor der Empfaenger die Fehlerseite sieht - und wenn es dann
  // immer noch klemmt, den Grund mit anzeigen, statt nur "Es ist ein Fehler
  // aufgetreten". Sonst haben wir bei einer Rueckmeldung nichts in der Hand.
  const LOAD_RETRY_DELAY_MS = 1200;
  const SUBMIT_RETRY_DELAY_MS = 1500;

  root.querySelector('[data-action="retry"]')?.addEventListener('click', runLoad);

  runLoad();

  // ───────────────────────────────────────────────────────────────────────
  function runLoad() {
    setErrorDetail('');
    showState('LOADING');
    loadWithRetry().catch((err) => {
      console.error('[sponsoring] load failed', err);
      setErrorDetail(errorLabel(err));
      showState('ERROR');
    });
  }

  async function loadWithRetry() {
    if ((await loadInquiry()) !== 'retry') return;
    await sleep(LOAD_RETRY_DELAY_MS);
    if ((await loadInquiry()) === 'retry') showState('ERROR');
  }

  // Rueckgabe: 'done' = Zustand steht (Form, Erfolg, Link ungueltig, ...),
  //            'retry' = technisch schiefgegangen, ein zweiter Versuch lohnt.
  async function loadInquiry() {
    let res;
    try {
      res = await fetch(`/apps/rma/api/sponsoring/load?token=${encodeURIComponent(token)}`, {
        headers: { Accept: 'application/json' },
      });
    } catch (err) {
      console.error('[sponsoring] load request failed', err);
      setErrorDetail(errorLabel(err));
      return 'retry';
    }
    if (!res.ok) {
      console.error('[sponsoring] load returned', res.status);
      setErrorDetail(`HTTP ${res.status}`);
      return 'retry';
    }
    // Der App-Proxy kann bei Stoerungen eine HTML-Fehlerseite mit Status 200
    // ausliefern - dann wirft json() und wir stehen ohne Diagnose da.
    let data;
    try {
      data = await res.json();
    } catch (err) {
      console.error('[sponsoring] load response was not JSON', err);
      setErrorDetail(`HTTP ${res.status}, Antwort war kein JSON`);
      return 'retry';
    }
    if (!data || data.ok === false) {
      const status = data?.status || 'not-found';
      const state = statusToUiState(status);
      if (state === 'ERROR') setErrorDetail(`Status: ${status}`);
      showState(state);
      return 'done';
    }
    if (data.ok && data.status === 'ok') {
      if (data.prefill) prefillForm(data.prefill);
      if (data.eventDate) renderEventDate(data.eventDate);
      attachActions();
      enforceThemeLimit();
      showState('FORM');
      return 'done';
    }
    setErrorDetail(`Status: ${data.status || 'unbekannt'}`);
    showState('ERROR');
    return 'done';
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function errorLabel(err) {
    const msg = err && err.message ? err.message : String(err || '');
    return msg ? `Netzwerk: ${msg}` : 'Netzwerkfehler';
  }

  // Technische Angabe unter der Fehlermeldung - fuer den Empfaenger belanglos,
  // aber genau das, was auf dem Screenshot steht, den er uns schickt.
  function setErrorDetail(text) {
    const el = root.querySelector('[data-target="error-detail"]');
    if (!el) return;
    if (!text) {
      el.textContent = '';
      el.hidden = true;
      return;
    }
    el.textContent = `${strings.error_detail_prefix || ''} ${text}`.trim();
    el.hidden = false;
  }

  function renderEventDate(iso) {
    const el = root.querySelector('[data-target="event-line"]');
    if (!el) return;
    try {
      const d = new Date(iso);
      const formatted = d.toLocaleDateString(root.dataset.locale || undefined, {
        day: '2-digit', month: '2-digit', year: 'numeric'
      });
      el.textContent = `${strings.event_prefix || ''} ${formatted}`.trim();
      el.hidden = false;
    } catch {
      el.hidden = true;
    }
  }

  function prefillForm(prefill) {
    if (!form) return;
    Object.entries(prefill).forEach(([k, v]) => {
      const input = form.querySelector(`[name="${k}"]`);
      if (input && typeof v === 'string') input.value = v;
    });
  }

  // Nur einmal verdrahten: nach "Erneut versuchen" laeuft loadInquiry() erneut
  // durch, und ein zweiter Listener am Absenden-Knopf wuerde doppelt abschicken.
  let actionsAttached = false;

  function attachActions() {
    if (actionsAttached) return;
    actionsAttached = true;
    form?.querySelector('[data-action="submit"]')?.addEventListener('click', submitForm);
  }

  let themeLimitAttached = false;

  // Max 4 Themen (sind ohnehin nur 4 verfuegbar, aber gegen Doppel-Klick-
  // Edge-Cases sicherstellen). Sichtbares Feedback erhaelt der User durch
  // den fehlenden Submit-Erfolg falls > 4, hier blockieren wir defensiv.
  function enforceThemeLimit() {
    if (themeLimitAttached) return;
    themeLimitAttached = true;
    const boxes = form?.querySelectorAll('input[name="theme"]') ?? [];
    boxes.forEach((cb) => {
      cb.addEventListener('change', () => {
        const checked = form.querySelectorAll('input[name="theme"]:checked');
        if (checked.length > 4) {
          cb.checked = false;
          const errEl = form.querySelector('[data-error="form"]');
          if (errEl) errEl.textContent = strings.err_too_many_themes || 'Maximal 4 Themen.';
        } else {
          const errEl = form.querySelector('[data-error="form"]');
          if (errEl) errEl.textContent = '';
        }
      });
    });
  }

  async function submitForm() {
    const errEl = form?.querySelector('[data-error="form"]');
    if (errEl) errEl.textContent = '';

    const themes = Array.from(form?.querySelectorAll('input[name="theme"]:checked') ?? []).map(
      (i) => i.value,
    );
    if (themes.length === 0 || themes.length > 4) {
      if (errEl) errEl.textContent = strings.err_validation || 'Bitte alle Pflichtfelder ausfuellen.';
      return;
    }

    const fd = new FormData(form);
    const firstName = (fd.get('firstName') || '').toString().trim();
    const lastName = (fd.get('lastName') || '').toString().trim();
    const street = (fd.get('street') || '').toString().trim();
    const zip = (fd.get('zip') || '').toString().trim();
    const city = (fd.get('city') || '').toString().trim();
    const country = (fd.get('country') || '').toString().trim();

    if (!firstName || !lastName || !street || !zip || !city || !country || !/^[A-Za-z]{2}$/.test(country)) {
      if (errEl) errEl.textContent = strings.err_validation || 'Bitte alle Pflichtfelder ausfuellen.';
      return;
    }

    const address = {
      firstName,
      lastName,
      company: (fd.get('company') || '').toString().trim(),
      street,
      address2: (fd.get('address2') || '').toString().trim(),
      zip,
      city,
      country: country.toUpperCase(),
      email: (fd.get('email') || '').toString().trim(),
    };

    setSubmitting(true);
    setSubmitDetail('');
    try {
      // Ein technischer Fehlschlag (keine Antwort, 5xx, kein JSON) wird einmal
      // automatisch wiederholt. Das ist ungefaehrlich: kam der erste Versuch
      // doch an, antwortet der zweite mit invalid_status -> "bereits eingereicht".
      let result = await postSubmit({ token, themes, address });
      if (result.kind === 'technical') {
        await sleep(SUBMIT_RETRY_DELAY_MS);
        result = await postSubmit({ token, themes, address });
      }

      if (result.kind === 'ok') {
        showState('SUCCESS');
      } else if (result.kind === 'already') {
        showState('ALREADY_SUBMITTED');
      } else if (result.kind === 'not_found') {
        showState('NOT_FOUND');
      } else if (result.kind === 'invalid') {
        if (errEl) errEl.textContent = result.message || strings.err_validation || 'Eingabe ungueltig.';
      } else {
        // Nicht auf die Fehlerseite wechseln: deren "Erneut versuchen" laedt
        // den Vorgang neu und das ausgefuellte Formular waere weg. Stattdessen
        // bleibt das Formular stehen, mit Hinweis und dem Weg per Mail
        // (Schiller-LAN, 07.09.2026: "HTTP 0" auf der Fehlerseite, Daten per
        // Mail geschickt, Nachricht blieb liegen).
        console.error('[sponsoring] submit failed', result.detail);
        if (errEl) {
          errEl.textContent =
            strings.err_submit_failed ||
            'Das Absenden hat gerade nicht geklappt. Bitte versuche es gleich noch einmal oder antworte auf unsere Mail mit deinen Themen und der Lieferadresse.';
        }
        setSubmitDetail(result.detail);
      }
    } finally {
      setSubmitting(false);
    }
  }

  // Rueckgabe: { kind: 'ok' | 'already' | 'not_found' | 'invalid' | 'technical', ... }
  async function postSubmit(payload) {
    let res;
    try {
      res = await fetch('/apps/rma/api/sponsoring/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      return { kind: 'technical', detail: errorLabel(err) };
    }
    const data = await res.json().catch(() => null);
    if (res.ok && data && data.ok !== false) return { kind: 'ok' };
    const err = data?.error;
    if (err === 'invalid_status') return { kind: 'already' };
    if (err === 'not_found') return { kind: 'not_found' };
    if (err === 'invalid_input' || err === 'invalid_themes' || err === 'invalid_address') {
      return { kind: 'invalid', message: data?.message };
    }
    if (res.status === 0) return { kind: 'technical', detail: 'HTTP 0 (keine Antwort erhalten)' };
    if (!data) return { kind: 'technical', detail: `HTTP ${res.status}, Antwort war kein JSON` };
    return { kind: 'technical', detail: res.ok ? `Status: ${err || 'unbekannt'}` : `HTTP ${res.status}, ${err || 'error'}` };
  }

  function setSubmitDetail(text) {
    const el = form?.querySelector('[data-target="submit-detail"]');
    if (!el) return;
    el.textContent = text ? `${strings.error_detail_prefix || ''} ${text}`.trim() : '';
    el.hidden = !text;
  }

  function setSubmitting(on) {
    root.querySelectorAll('button').forEach((b) => {
      b.disabled = !!on;
    });
  }

  function showState(name) {
    root.querySelectorAll('[data-state]').forEach((el) => {
      el.hidden = el.getAttribute('data-state') !== name;
    });
  }

  function statusToUiState(status) {
    if (status === 'already-submitted') return 'ALREADY_SUBMITTED';
    if (status === 'rejected') return 'REJECTED';
    if (status === 'not-found') return 'NOT_FOUND';
    return 'ERROR';
  }

  function decodeHtmlEntities(s) {
    const ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }
})();
